
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/international-flights/[[...param]]",
      function () {
        return require("private-next-pages/international-flights/[[...param]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/international-flights/[[...param]]"])
      });
    }
  